import BasicLayout from '@/layouts/basic-layout'

const prefix = 'storage-manage-contract-collection-payment-'
export default [
  {
    path: '/storage-manage/contract-collection-payment',
    redirect: {name: `${prefix}index`},
    component: BasicLayout,
    children: [
      {
        path: 'index',
        name: `${prefix}index`,
        meta: {title: '业主合同收付款情况管理'},
        component: () => import('@/pages/storage-manage/contract-collection-payment/index')
      },
      {
        path: 'detail-create',
        name: `${prefix}create`,
        auth: ['hidden'],
        meta: {title: '业主合同收付款情况新增'},
        component: () => import('@/pages/storage-manage/contract-collection-payment/detail-create')
      },
      {
        path: 'detail-edit/:id',
        name: `${prefix}edit`,
        auth: ['hidden'],
        meta: {cache: true, title: '业主合同收付款情况编辑'},
        component: () => import('@/pages/storage-manage/contract-collection-payment/detail-edit')
      },

      {
        path: 'detail-view/:id',
        name: `${prefix}view`,
        auth: ['hidden'],
        meta: {title: '业主合同收付款情况详情'},
        component: () => import('@/pages/storage-manage/contract-collection-payment/detail-view')
      }
    ]
  }
]
